// A single event_id ties the server-side conversion (Meta CAPI / GA4 Measurement
// Protocol) to the browser pixel fire so Meta/Google collapse them into ONE event.
// Minted once per booking and persisted in bookings.attribution.purchase_event_id,
// so both the confirmation-page browser fire and the webhook-driven server fire
// use the same id regardless of which lands first.
export function generateEventId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) return crypto.randomUUID();
  return "evt-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 12);
}
